"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemPickerStyles = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ItemPickerStyles = _styledComponents["default"].div.withConfig({
  componentId: "sc-1j5ccny-0"
})(["border:solid 1px ", ";border-radius:2px;margin-top:20px;input{display:none;}.horizontal{.radio-button{border-right:solid 1px ", ";cursor:pointer;margin-right:0;width:100%;&:last-child{border-right:none;}&:hover{background-color:", ";cursor:pointer;}label{cursor:pointer;justify-content:center;margin:0;padding:20px 0;width:100%;&:focus{background-color:", ";}}&.selected{background-color:", ";label,label:focus{background-color:", ";color:#ffffff;}}}}"], _colors["default"].accent.grey3.standard, _colors["default"].accent.grey3.standard, _colors["default"].primary.claytonBlue.tint, _colors["default"].primary.claytonBlue.tint, _colors["default"].primary.claytonBlue.standard, _colors["default"].primary.claytonBlue.standard);

exports.ItemPickerStyles = ItemPickerStyles;